import React, { useState } from 'react';

export default function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <nav className="fixed w-full top-0 z-50">
      {/* Gradient Background Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#F9F0F3] via-[#F7E8EF]/98 to-transparent backdrop-blur-[2px]" />
      
      {/* Main Navbar Content */}
      <div className="relative container mx-auto px-4 lg:px-8 py-4 lg:py-7">
        <div className="flex items-center justify-between">
          {/* Transforming Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="lg:hidden flex flex-col items-center p-2 z-50"
            aria-label={isMenuOpen ? 'Close menu' : 'Open menu'}
          >
            <div className="relative w-6 h-6 flex items-center justify-center">
              <span className={`
                absolute w-6 h-[1px] bg-[#5A3B5D] transform transition-all duration-300
                ${isMenuOpen ? 'rotate-45' : 'translate-y-[-4px]'}
              `} />
              <span className={`
                absolute w-6 h-[1px] bg-[#5A3B5D] transform transition-all duration-300
                ${isMenuOpen ? 'opacity-0' : 'opacity-100'}
              `} />
              <span className={`
                absolute w-6 h-[1px] bg-[#5A3B5D] transform transition-all duration-300
                ${isMenuOpen ? '-rotate-45' : 'translate-y-[4px]'}
              `} />
            </div>
            <span className="text-[10px] uppercase tracking-wider mt-1 text-[#5A3B5D]">Menu</span>
          </button>

          {/* Left Menu - Hidden on mobile */}
          <div className="hidden lg:flex space-x-12">
            <a href="/" className="text-sm tracking-wide uppercase text-gray-800/90 hover:text-[#A47C89] transition-all duration-300 font-light">
              Home
            </a>
            <a href="/about-us" className="text-sm tracking-wide uppercase text-gray-800/90 hover:text-[#A47C89] transition-all duration-300 font-light">
              About Us
            </a>
            <a href="/services" className="text-sm tracking-wide uppercase text-gray-800/90 hover:text-[#A47C89] transition-all duration-300 font-light">
              Services
            </a>
          </div>

          {/* Centered Logo */}
          <a href="/" className="absolute left-1/2 -translate-x-1/2 -translate-y-1">
            <img
              src="/images/navbar/logo.png"
              alt="Cut N Curls Logo"
              className="h-12 lg:h-20 w-auto transition-all duration-300"
            />
          </a>

          {/* Right Menu - Hidden on mobile */}
          <div className="hidden lg:flex items-center space-x-12">
            <a href="/gallery" className="text-sm tracking-wide uppercase text-gray-800/90 hover:text-[#A47C89] transition-all duration-300 font-light">
              Gallery
            </a>
            <a href="/contact-us" className="text-sm tracking-wide uppercase text-gray-800/90 hover:text-[#A47C89] transition-all duration-300 font-light">
              Contact Us
            </a>
            <a
              href="https://square.site/book/5CPJFK4WYVQF3/cut-n-curls-salon-manhasset-ny"
              className="bg-[#A47C89] text-white px-8 py-2.5 rounded-full hover:bg-[#916573] transition-all duration-300 font-light tracking-wide text-sm uppercase shadow-md hover:shadow-lg"
            >
              Book Now
            </a>
          </div>

          {/* Mobile Book Button */}
          <div className="lg:hidden">
            <a
              href="https://square.site/book/5CPJFK4WYVQF3/cut-n-curls-salon-manhasset-ny"
              className="bg-[#A47C89] text-white px-4 py-2 rounded-full hover:bg-[#916573] transition-all duration-300 font-light tracking-wide text-sm uppercase shadow-md hover:shadow-lg"
            >
              Book
            </a>
          </div>
        </div>

        {/* Backdrop Blur when menu is open */}
        {isMenuOpen && (
          <div className="fixed inset-0 bg-white/30 backdrop-blur-sm transition-all duration-500" />
        )}

        {/* Side Panel Mobile Menu */}
        <div 
          className={`
            lg:hidden 
            fixed 
            inset-y-0 
            right-0
            w-[85vw] 
            max-w-md
            transition-transform 
            duration-500 
            ease-in-out
            ${isMenuOpen ? 'translate-x-0 visible' : 'translate-x-full invisible'}
          `}
        >
          {/* Background with Skew */}
          <div className="absolute inset-0 bg-[#A47C89] transform -skew-x-[14deg] origin-left opacity-95" />

          {/* Menu Links */}
          <ul className="
            relative 
            h-full 
            flex 
            flex-col 
            justify-center 
            items-end 
            pr-16
            transform 
            -skew-x-[16deg]
          ">
            {[
              { href: '/', text: 'Home' },
              { href: '/about-us', text: 'About Us' },
              { href: '/services', text: 'Services' },
              { href: '/gallery', text: 'Gallery' },
              { href: '/contact-us', text: 'Contact Us' }
            ].map((link, index) => (
              <li key={link.href} className="block mb-8 text-right transform skew-x-[16deg]">
                <a
                  href={link.href}
                  className={`
                    block 
                    text-white
                    text-2xl 
                    font-light
                    tracking-wide
                    uppercase
                    hover:translate-x-[-8px]
                    transition-all 
                    duration-300
                    ${isMenuOpen 
                      ? 'opacity-100 translate-y-0' 
                      : 'opacity-0 translate-y-4'
                    }
                  `}
                  style={{
                    transitionDelay: isMenuOpen ? `${175 + (index * 50)}ms` : '0ms'
                  }}
                >
                  {link.text}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </nav>
  );
}